import React, {useEffect, useState} from 'react';
import {useServiceBase} from "../Components/ReactTable/useServiceBase";
import {INDEX_FIELD} from "../Components/ReactTable/common_custom_columns";
import Page from "../Components/Page";
import {Breadcrumbs} from "../Components/Breadcrumbs";
import {LoadingWrapper} from "../Components/LoadingWrapper";
import EditableReactTableV2 from "../Components/ReactTable/EditableReactTableV2";
import {EditFormDropdownInputField, EditFormNumberInputField} from "../Components/ReactTable/EditRecordForm";
import RetailerIdAndName from "../Components/RetailerIdAndName";
import {serviceRetailerDropdown} from "../../utils/retailerDisplayFormatter";
import {makeApolloClientCall} from "../../Api/makeApolloApiCall";

function SkipDailyFill() {

    const endpointUrl = `${process.env.REACT_APP_EDP_API_BASE_URL}/skipDailyFill/`
    const {loading, data, onRowEditConfirmed, onRowDeleteConfirmed} = useServiceBase({endpointUrl});

    const [isLoading, updateIsLoading] = useState(true);

    const columns = [
        {header: "Week End Date", accessorKey: "weekEndDate"},
        {header: 'Retailer', accessorKey: 'retailerId', cell: ({row}) => <RetailerIdAndName retailerId={row.original.retailerId}/>,},
        {header: "Store Id", accessorKey: "storeId"},
    ];
    const [periodOptions, updatePeriodOptions] = useState([]);

    useEffect(() => {
        updateIsLoading(true)
        Promise.all([
            makeApolloClientCall(`query Periods { periods { endDate } }`),
        ]).then(([periods]) => {
            updatePeriodOptions(periods.periods.map((week) => ({value: week.endDate, label: week.endDate})));
        }).finally(() => {
            updateIsLoading(false)
        });
    }, []);

    return (<Page name={"Skip Daily Fill"} breadCrumbs={<Breadcrumbs items={[{label: "Configurations"}, {label: "Retailer"}, {label: "Skip Daily Fill"}]}/>}>
        <LoadingWrapper loading={loading || isLoading}>
            <EditableReactTableV2
                filterable
                data={data.data}
                columns={columns}
                initialState={{ pagination: { pageSize: 25 } }}
                editTable={[
                    INDEX_FIELD,
                    {id: 'weekEndDate', Component: args => <EditFormDropdownInputField  {...args} label={"Week End Date"} options={periodOptions} isRequired/>},
                    {id: 'retailerId', Component: args => <EditFormDropdownInputField {...args} label={"Retailer"} options={serviceRetailerDropdown().data} isRequired/> },
                    {id: 'storeId', Component: args => <EditFormNumberInputField {...args} label={"Store Id"}/>},
                ]}
            onRowEditConfirmed={onRowEditConfirmed}
            onRowDeleteConfirmed={onRowDeleteConfirmed}
        />
        </LoadingWrapper>
    </Page>);
}

export default SkipDailyFill;
